export default "/images/save-and-close-icon.svg?0b7baa511a688c0a5cb65b3b4fcecdf5";